var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNo08(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 818.3 1301.6",
    style: {
      enableBackground: "new 0 0 818.3 1301.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000121278317222082590570000006392425197978981566_);fill:#FC7685;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 818.3,
    height: 1301.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000060742702953473430370000011107917387348205196_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000060742702953473430370000011107917387348205196_)",
      fill: "#FC7685"
    },
    d: "M54.3,711.5 c36.2-57.9,90.5-94.1,162.9-108.6v-3.6c-35-8.4-64.3-21.7-87.8-39.8c-23.5-18.1-42.5-38.6-57-61.6c-14.5-22.9-24.8-47.1-30.8-72.4 c-6.1-25.3-9.1-49.5-9.1-72.4c0-125.5,33.5-215.7,100.5-270.6C200,27.5,292.1,0,409.1,0c117,0,209.1,27.5,276.1,82.4 c67,54.9,100.5,145.1,100.5,270.6c0,22.9-3.3,47.1-10,72.4c-6.6,25.3-17.2,49.5-31.7,72.4c-14.5,22.9-33.5,43.4-57,61.6 c-23.5,18.1-52.2,31.4-86,39.8v3.6c72.4,14.5,126.7,50.7,162.9,108.6c36.2,57.9,54.3,127.3,54.3,208.2c0,37.4-4.5,78.5-13.6,123.1 c-9.1,44.7-28.1,86.3-57,124.9c-29,38.6-70.3,70.6-124,95.9c-53.7,25.3-125.2,38-214.5,38c-89.3,0-160.8-12.7-214.5-38 c-53.7-25.3-95-57.3-124-95.9c-29-38.6-48-80.2-57-124.9C4.5,998.1,0,957.1,0,919.6C0,838.8,18.1,769.4,54.3,711.5 M316.8,481.5 c22.9,29,53.7,43.4,92.3,43.4c38.6,0,69.4-14.5,92.3-43.4c22.9-29,34.4-74.2,34.4-135.8c0-117-42.3-175.6-126.7-175.6 c-84.5,0-126.7,58.6-126.7,175.6C282.4,407.3,293.9,452.6,316.8,481.5 M267,1002c4.2,27.2,12,50.7,23.5,70.6 c11.5,19.9,26.8,35.6,46.2,47.1c19.3,11.5,43.4,17.2,72.4,17.2s53.1-5.7,72.4-17.2c19.3-11.5,34.7-27.2,46.2-47.1 c11.5-19.9,19.3-43.4,23.5-70.6c4.2-27.2,6.3-55.8,6.3-86c0-31.4-2.1-60.3-6.3-86.9c-4.2-26.5-12.1-49.8-23.5-69.7 c-11.5-19.9-26.9-35.6-46.2-47.1c-19.3-11.5-43.4-17.2-72.4-17.2s-53.1,5.7-72.4,17.2c-19.3,11.5-34.7,27.2-46.2,47.1 c-11.5,19.9-19.3,43.2-23.5,69.7c-4.2,26.6-6.3,55.5-6.3,86.9C260.7,946.2,262.8,974.9,267,1002"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo08);
export default __webpack_public_path__ + "static/media/no-08.02f61fecc8d5ca04a9669bbd00afce87.svg";
export { ForwardRef as ReactComponent };